import { Reveal, SectionHeading } from "./shared";
import { IMAGES } from "./content";

const SETS = [
    {
        id: "set-card-sleigh",
        num: "01",
        name: "Santa's Sleigh",
        tag: "A magical ride through the snow",
        desc: "A vintage red sleigh with gold scrollwork, nestled in a forest of frosted pines and soft snowdrifts, made for wide-eyed little ones with presents to hold.",
        img: IMAGES.sleigh,
        alt: "Santa's Sleigh Christmas set with frosted pine trees at Essex Photography Studio",
        arch: true,
        pos: "center 76%",
    },
    {
        id: "set-card-workshop",
        num: "02",
        name: "Lapland Workshop",
        tag: "Straight from the North Pole",
        desc: "A cosy toy-shop scene with warm brick, shelves of teddy bears and treasures, and a forest of glowing Christmas trees, straight out of a Christmas story.",
        img: IMAGES.toyshop,
        alt: "Lapland Toy Shop Christmas set with teddy bears and wrapped gifts at Essex Photography Studio",
        arch: false,
        pos: "center 40%",
    },
];

export default function Sets() {
    return (
        <section id="sets" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <SectionHeading
                    eyebrow="Two Handcrafted Sets"
                    title="One session. Two worlds straight out of a Christmas story."
                    sub="Every 20-minute session moves between both sets, so your gallery gets the sparkle of the snow and the warmth of the workshop."
                />
                <div className="mt-16 grid gap-14 lg:grid-cols-2 lg:gap-10">
                    {SETS.map((s, i) => (
                        <Reveal key={s.id} delay={i * 0.12} data-testid={s.id}>
                            <article className="group spotlight-card glass-card rounded-3xl p-4 transition-shadow duration-500 hover:shadow-[0_20px_60px_rgba(212,175,55,0.18)] sm:p-5">
                                <div
                                    className={`relative overflow-hidden ${
                                        s.arch ? "rounded-b-2xl rounded-t-[999px]" : "rounded-2xl"
                                    }`}
                                >
                                    <img
                                        src={s.img}
                                        alt={s.alt}
                                        loading="lazy"
                                        style={{ objectPosition: s.pos }}
                                        className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                                    />
                                    <span className="absolute left-5 top-5 rounded-full bg-pine-950/80 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.28em] text-gold backdrop-blur">
                                        Set {s.num}
                                    </span>
                                </div>
                                <div className="px-2 pb-3 pt-6 sm:px-4">
                                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
                                        {s.tag}
                                    </p>
                                    <h3 className="mt-2 font-serif text-2xl font-bold text-cream sm:text-3xl">
                                        {s.name}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-mist sm:text-base">
                                        {s.desc}
                                    </p>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
